<template>
  <div class="card kit-data kit-results card-shrink">
    <div class="header-item btn-back" @click="$emit('back')">
      <font-awesome-icon
        style="margin-right: 10px;"
        :icon="['fa', 'arrow-left']"
      />
      <span class="desktop">Voltar</span>
    </div>
    <div class="rsl-header">
      <div
        class="header-item active"
        v-if="result.kit_type_id > 2"
        @click="$emit('changeView', 'rsl')"
      >
        <span class="item-text">Resultados</span>
      </div>
      <div
        class="header-item"
        v-if="result.kit_type_id > 2 && result.kit_type_id < 7"
        @click="$emit('changeView', 'rsk')"
      >
        <span class="item-text">Riscos</span>
      </div>
      <div class="header-item" @click="$emit('download', result.id)">
        <font-awesome-icon
          class="desktop"
          style="margin-right: 5%;"
          :icon="['fa', 'receipt']"
        />
        Laudo
      </div>
      <!-- <button class="button btn-primary btn-min" v-if="result.kit_type_id > 2" @click="$emit('changeView', 'pln')">Plano de cuidados</button>
            <button class="button btn-primary btn-min" @click="$emit('changeView', 'tps')">Dicas</button> -->
    </div>
    <div class="content">
      <span class="title">Testes e resultados</span>
      <h2>{{ result.kit_type.name }}</h2>
      <template
        v-if="result.kit_type.tag_type === 'exame-litio'"
      >
        <!-- <p>
          Descrição do teste.
        </p> -->
      </template>
      <template
        v-if="result.kit_type.tag_type === 'check-up-anticorpos-igg-covid'"
      >
        <p>
          Este Check-up é indicado para quem teve contato com o vírus SARS-CoV-2
          da COVID-19.
        </p>
        <p>
          Quando temos contato com o vírus SARS-CoV-2, o sistema imunológico do
          corpo organiza defesas capazes de limitar a ação de tais organismos
          estranhos e gerar uma proteção quantos aos sintomas mais graves em uma
          futura reinfecção.
        </p>
        <p>
          A boa notícia é que isso ocorre por meio da produção de anticorpos
          naturais, sendo o IgG um deles, e que pode ser verificado através do
          nosso Check-up Anticorpos IgG Covid. Desta forma, o resultado do seu
          exame serve justamente para identificar se você teve em seu organismo
          a produção desse anticorpo, através de contato com o vírus.
        </p>
        <p>
          Todavia, é fundamental continuar usando máscara e a fazer
          distanciamento social seguindo as recomendações dos órgãos
          competentes.
        </p>
      </template>
      <template
        v-if="result.kit_type.tag_type === 'check-up-anticorpos-vacina-covid'"
      >
        <p>
          Este Check-up é indicado a partir do momento em que temos contato com
          a vacina e recebemos determinada carga do antídoto a fim de provocar a
          produção de anticorpos em nosso organismo.
        </p>
        <p>
          Quando esse processo é bem-sucedido o corpo torna-se capaz de combater
          o vírus em uma futura infecção, gerando uma proteção quanto aos
          sintomas e quadros mais graves. O exame em questão quantifica o
          domínio S1 viral (Proteína Spike).
        </p>
        <p>
          A boa notícia é que você consegue avaliar a quantidade de anticorpos
          neutralizadores do vírus SARS-CoV-2 da COVID-19 gerados em seu
          organismo após a aplicação da primeira ou segunda dose da vacina,
          quando for o caso, com o nosso Check-up Anticorpos Quantivac.
        </p>
        <p>
          Todavia, mesmo após as duas doses da vacina é fundamental continuar
          usando máscara e a fazer distanciamento social seguindo as
          recomendações dos órgãos competentes.
        </p>
      </template>

      <template v-if="result.kit_type.tag_type === 'check-up-saude-do-coracao'">
        <p>
          As Doenças Cardiovasculares, mais conhecidas como Doenças do Coração,
          estão entre as principais caudas de morte no mundo. Um dos principais
          motivos é porque os sintomas mais comuns podem passar de forma
          imperceptível, tendo em vista a vida que levamos: cansaço frequente;
          palpitações; suor frio; tonturas; dores no peito; enjoo ou perda de
          apetite e etc.
        </p>
        <p>
          A boa notícia é que para prevenir as Doenças do Coração, basta
          realizar check-ups com frequência, melhorar hábitos alimentares,
          realizar atividades físicas e cuidar do bem-estar emocional.
        </p>
        <p>
          Controlar o colesterol, a pressão arterial, para de fumar e perder
          peso são as principais ferramentas contra as Doenças do Coração.
        </p>
      </template>
      <template v-if="result.kit_type.tag_type === 'check-up-saude-preventiva'">
        <p>
          A saúde preventiva é um conjunto de medidas e práticas que visam
          evitar o surgimento de doenças e promover o bem-estar físico e mental.
          É um enfoque proativo que se concentra na prevenção em vez de tratar
          doenças já estabelecidas. A importância da saúde preventiva reside no
          fato de que muitas doenças podem ser evitadas ou diagnosticadas
          precocemente por meio de exames regulares, estilo de vida saudável e
          adoção de medidas preventivas específicas.
        </p>
        <p>
          A boa notícia é que para prevenir, basta realizar check-ups com
          frequência, melhorar hábitos alimentares, realizar atividades físicas
          e cuidar do bem-estar emocional.
        </p>
        <p>
          A saúde preventiva é um investimento valioso, que proporciona
          bem-estar físico, emocional e social, permitindo que desfrutemos de
          uma vida longa e saudável.
        </p>
      </template>
      <template v-if="result.kit_type.tag_type === 'check-up-doencas-cronicas'">
        <p>
          As Doenças Crônicas são aquelas que duram mais de um ano e precisam de
          cuidados médicos praticamente constantes. Diabetes e problemas
          cardiovasculares estão na lista que reúne as principais causas de
          internações médicas no Brasil e no mundo.
        </p>
        <p>
          Além dos fatores genéticos, a alimentação inadequada, obesidade, uso
          de álcool, cigarro e outras drogas, sedentarismo e falta de descanso
          são os principais fatores que levam ao desenvolvimento dessas
          patologias. A boa notícia é que para prevenir as Doenças Crônicas,
          basta realizar check-ups com frequência, melhorar hábitos alimentares,
          realizar atividades físicas e cuidar do bem-estar emocional.
        </p>
        <p>
          Controlar o colesterol, a pressão arterial, para de fumar e beber em
          acesso, perder peso são as principais ferramentas contra as Doenças
          Crônicas.
        </p>
      </template>
      <template
        v-if="result.kit_type.tag_type === 'check-up-longevidade-saudavel'"
      >
        <p>
          Longevidade nada mais é do que viver mais. E aqui vamos conduzir você
          a viver mais e com qualidade, identificando riscos atrelados à saúde,
          bem como o risco de vir a desenvolver doenças crônicas ou demais
          patologias. A pessoa com mais idade pode ter alteração na imunidade e
          maior risco de infecção, por exemplo. Desta forma, a chance de ter um
          melhor envelhecimento está ligada diretamente a hábitos saudáveis e
          características pessoais.
        </p>
        <p>
          A boa notícia é que para ajudar você nesta etapa e prevenir doenças,
          basta realizar check-ups com frequência, melhorar hábitos alimentares,
          realizar atividades físicas e cuidar do bem-estar emocional.
        </p>
      </template>
      <template
        v-if="
          result.kit_type.tag_type === 'check-up-anticorpos-igg-covid' ||
            result.kit_type.tag_type === 'check-up-anticorpos-vacina-covid'
        "
      >
        <value-card
          v-if="result.kit_type.tag_type === 'check-up-anticorpos-igg-covid'"
          :title="'Valor'"
          :altTitle="'igg'"
          :result="igg"
          :labels="igg.metric_labels"
          @openModal="openModal"
        />
        <value-card
          v-if="result.kit_type.tag_type === 'check-up-anticorpos-vacina-covid'"
          :title="'Valor'"
          :altTitle="'quantivac'"
          :result="quantivac"
          :labels="quantivac.metric_labels"
          :quantivac="true"
          @openModal="openModal"
        />
      </template>
      <template v-else>
        <value-card
          v-if="!!litio"
          :title="'Lítio'"
          :altTitle="'litio'"
          :result="litio"
          :labels="litio.metric_labels"
          :litio="true"
          @openModal="openModal"
        />
        <value-card
          v-if="!!hdl"
          :title="'Colesterol HDL'"
          :altTitle="'hdl'"
          :result="hdl"
          :labels="hdl.metric_labels"
          @openModal="openModal"
        />
        <value-card
          v-if="!!ldl"
          :title="'Colesterol LDL'"
          :altTitle="'ldl'"
          :result="ldl"
          :labels="ldl.metric_labels"
          @openModal="openModal"
        />
        <value-card
          v-if="!!hba1c"
          :title="'Hemoglobina Glicada (HbA1c)'"
          :altTitle="'hba1c'"
          :result="hba1c"
          :labels="hba1c.metric_labels"
          :percentage="true"
          @openModal="openModal"
        />
        <value-card
          v-if="!!glicose"
          :title="'Glicose'"
          :result="glicose"
          :altTitle="'gli'"
          :labels="glicose.metric_labels"
          @openModal="openModal"
        />
        <value-card
          v-if="!!triglicerideos"
          :title="'Triglicerídeos'"
          :altTitle="'tri'"
          :result="triglicerideos"
          :labels="triglicerideos.metric_labels"
          @openModal="openModal"
        />
        <value-card
          v-if="!!colesterol"
          :title="'Colesterol total'"
          :altTitle="'clt'"
          :result="colesterol"
          :labels="colesterol.metric_labels"
          @openModal="openModal"
        />
        <value-card
          v-if="!!creatinine"
          :title="'Creatinina'"
          :altTitle="'creatinine'"
          :result="creatinine"
          :labels="creatinine.metric_labels"
          @openModal="openModal"
        />
        <value-card
          v-if="!!tfg"
          :title="'Filtração Glomerular Estimada'"
          :altTitle="'tfg'"
          :result="tfg"
          :labels="tfg.metric_labels"
          :tfg="true"
          @openModal="openModal"
        />
      </template>
    </div>
    <div>
      <table class="reference-table">
        <thead>
          <tr>
            <th>
              Fase do tratamento
            </th>
            <th>
              Concentração sérica
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              Fase aguda (episódios)
            </td>
            <td>
              0,8-1,2 mEq/L
            </td>
          </tr>
          <tr>
            <td>
              Manutenção (profilaxia)
            </td>
            <td>
              0,6-0,8 mEq/L
            </td>
          </tr>
          <tr>
            <td>
              Idosos / maior sensibilidade
            </td>
            <td>
              0,4-0,6 mEq/L
            </td>
          </tr>
          <tr>
            <td>
              Tóxico
            </td>
            <td>
              >1,5 mEq/L
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <span class="footer-text">Em caso de dúvida fale com seu médico para saber em qual fase do tratamento você se encontra</span>
    <span v-if="[1, 2].includes(result.kit_type_id)" class="footer-text"
      >Exames processados pelo Euroimmun Brasil Medicina Diagnóstica LTDA.</span
    >
    <span v-else-if="[7].includes(result.kit_type_id)" class="footer-text"
      >Exames processados pelo Laboratório de Análises Clínicas e Toxicológicas da Universidade Feevale.</span
    >
    <span v-else class="footer-text"
      >Exames processados pelo Laboratório Health ID LAB Diagnóstica.</span
    >
    <text-modal
      :exam="textModalExam"
      :diseases="diseases"
      @close="openModal(false)"
      v-if="textModal"
    />
  </div>
</template>
<script>
import ValueCard from "./ValueCard";
import TextModal from "./TextModal";
import moment from "moment";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

library.add(faArrowLeft);

export default {
  name: "kit-results",
  components: { ValueCard, TextModal },
  props: {
    result: Object,
  },
  data() {
    return {
      igg: null,
      quantivac: null,
      hdl: null,
      ldl: null,
      hba1c: null,
      glicose: null,
      triglicerideos: null,
      colesterol: null,
      creatinine: null,
      tfg: null,
      litio: null,
      diseases: {
        hasHeartDisease: false,
        hasDiabetes: false,
        hasHypertension: false,
        hasAvc: false,
        hasDyslipidimia: false,
        hasMetabolic: false,
        hasOsteoporosis: false
      },
      customer: null,
      textModal: false,
      textModalExam: {}
    };
  },
  methods: {
    back() {
      this.$emit("back");
    },
    getDiseases() {
      this.diseases.hasHeartDisease =
        this.answerSearch("Você é portador de alguma doença do coração?") ==
        "Sim"
          ? true
          : false;
      this.diseases.hasDiabetes =
        this.answerSearch("Você é portador de Diabetes?") ==
          "Sim, Descontrolada" ||
        this.answerSearch("Você é portador de Diabetes?") == "Sim, Controlada"
          ? true
          : false;
      this.diseases.hasHypertension =
        this.answerSearch("Você é portador de Hipertensão?") != "Não"
          ? true
          : false;
      this.diseases.hasAvc = this.answerSearch(
        "Você é portador de quais doenças ou condições abaixo?",
        true
      ).includes("avc")
        ? true
        : false;
      this.diseases.hasDyslipidimia = this.answerSearch(
        "Você é portador de quais doenças ou condições abaixo?",
        true
      ).includes("dislipidemia")
        ? true
        : false;

      this.diseases.hasOsteoporosis = this.answerSearch(
        "Você é portador de quais doenças ou condições abaixo?",
        true
      ).includes("Osteoporose")
        ? true
        : false;
    },
    answerSearch(field, multiple = false, answers = []) {
      let ans = null;
      if (!!this.result.field_answers)
        if (multiple) {
          if (answers.length > 0) {
            ans = this.result.field_answers
              .filter(a => {
                return (
                  a.field.title == field && answers.includes(a.option.value)
                );
              })
              .map(a => {
                return a.option.value;
              });
            return ans.join(", ");
          } else {
            ans = this.result.field_answers
              .filter(a => {
                return a.field.title == field;
              })
              .map(a => {
                return a.option.value;
              });
            return ans;
          }
        } else {
          this.result.field_answers.map(answer => {
            if (answer.field.title == field && !multiple)
              ans =
                answer.response !== null
                  ? answer.response
                  : answer.option.label;
          });
        }
      return ans;
    },
    getAge(birth_date) {
      const now = moment();
      const birthdate = moment(birth_date);
      return now.diff(birthdate, "years");
    },
    openModal(open, title = null, exam = {}) {
      this.textModalExam = exam;
      this.textModalExam.title = title;
      this.textModal = open;
    }
  },
  mounted() {
    this.getDiseases();

    let cardiovascular = null;
    this.result.metric.forEach(risk => {
      if (risk.risk.name == "Risco Cardiovascular")
        cardiovascular = risk.ticket.label;
    });

    if (!!this.result) {
      if (!!this.result.customer) {
        this.customer = this.result.customer;

        if (!!this.customer.birth_date) {
          this.customer.age = this.getAge(this.customer.birth_date);
        }
      }
      if (!!this.result.exam && !!this.result.exam.result) {
        const result = this.result.exam.result;

        if (!!result.value) this.igg = { label: "", value: result.value };
        if (!!result.value) this.quantivac = { label: "", value: result.value };
        if (!!result.value && this.result.kit_type_id == 7) this.litio = { label: "", value: result.value };
        if (!!result.hdl) this.hdl = { label: "", value: result.hdl };
        if (!!result.ldl) this.ldl = { label: "", value: result.ldl };
        if (!!result.hba1c) this.hba1c = { label: "", value: result.hba1c };
        if (!!result.glicose)
          this.glicose = { label: "", value: result.glicose };
        if (!!result.triglicerideos)
          this.triglicerideos = {
            label: "",
            value: result.triglicerideos
          };
        if (!!result.colesterol_total)
          this.colesterol = { label: "", value: result.colesterol_total };
        if (!!result.creatinine)
          this.creatinine = { label: "", value: result.creatinine };
        if (!!result.tfg)
          this.tfg = { label: "", value: result.tfg.toFixed(2) };
      }
    }

    if(!!this.litio) {
      this.litio.metric_labels = [
        {
          name: "Subdosagem",
          color: "yellow",
          interval: { desc: "Inferior a 0,6 mEq/L", min: 0, max: 0.6 }
        },
        {
          name: "Normal",
          color: "green",
          interval: { desc: "De a 0,6 a 1,2 mEq/L", min: 0.6, max: 1.2 }
        },
        {
          name: "",
          color: "gray",
          interval: { desc: "De a 1,2 a 1,5 mEq/L", min: 1.2, max: 1.5 }
        },
        {
          name: "Risco de Toxicidade",
          color: "red",
          interval: { desc: "Superior ou igual a 1,5 mEq/L", min: 1.5, max: 2.4 }
        }
      ];

      if (this.litio.value <= 0.6) this.litio.label = "Subdosagem";
      else if (this.litio.value > 0.6 && this.litio.value <= 1.2) this.litio.label = "Normal";
      else if (this.litio.value > 1.2 && this.litio.value < 1.5) this.litio.label = "";
      else if (this.litio.value >= 1.5) this.litio.label = "Risco de Toxicidade";
      else this.litio.label = "ERRO!";
    }

    if (!!this.igg || !!this.quantivac) {
      if (this.result.kit_type.tag_type === "check-up-anticorpos-igg-covid") {
        this.igg.metric_labels = [
          {
            name: "Negativo",
            color: "dark-green",
            interval: { desc: "Inferior a 0.8 mg/dL", min: 0, max: 0.8 }
          },
          {
            name: "Indeterminado",
            color: "orange",
            interval: { desc: "De a 0.8 a 1 mg/dL", min: 0.8, max: 1.1 }
          },
          {
            name: "Positivo",
            color: "red",
            interval: {
              desc: "Superior ou igual a 1.1 mg/dL",
              min: 1.1,
              max: 2.2
            }
          }
        ];
        if (this.igg.value < 0.8) this.igg.label = "Negativo";
        else if (this.igg.value >= 0.8 && this.igg.value < 1.1)
          this.igg.label = "Indeterminado";
        else if (this.igg.value >= 1.1) this.igg.label = "Positivo";
      } else if (
        this.result.kit_type.tag_type === "check-up-anticorpos-vacina-covid"
      ) {
        this.quantivac.metric_labels = [
          {
            name: "Não detectado",
            color: "red",
            interval: { desc: "Inferior a 8 RU/ml", min: 0, max: 8 }
          },
          {
            name: "Indeterminado",
            color: "orange",
            interval: { desc: "De 8 RU/ml a 10 RU/ml", min: 8, max: 11 }
          },
          {
            name: "Elevado",
            color: "dark-green",
            interval: { desc: "Superior ou igual a 11 RU/ml", min: 11, max: 22 }
          }
        ];
        if (this.quantivac.value < 8) this.quantivac.label = "Não detectado";
        else if (this.quantivac.value >= 8 && this.quantivac.value < 11)
          this.quantivac.label = "Indeterminado";
        else if (this.quantivac.value >= 11) this.quantivac.label = "Elevado";
      }
    }

    if (!!this.colesterol && !!this.customer.age) {
      if (this.customer.age > 20) {
        this.colesterol.metric_labels = [
          {
            name: "Normal",
            color: "dark-green",
            interval: { desc: "Inferior a 190mg/dL", min: 0, max: 190 }
          },
          {
            name: "Elevado",
            color: "red",
            interval: {
              desc: "Superior ou igual a 190mg/dL",
              min: 190,
              max: 380
            }
          }
        ];
        if (this.colesterol.value < 190) this.colesterol.label = "Normal";
        else if (this.colesterol.value >= 190)
          this.colesterol.label = "Elevado";
        else this.colesterol.label = "Erro!";
      } else {
        this.colesterol.metric_labels = [
          {
            name: "Normal",
            color: "dark-green",
            interval: { desc: "Inferior a 190mg/dL", min: 0, max: 170 }
          },
          {
            name: "Elevado",
            color: "red",
            interval: {
              desc: "Superior ou igual a 190mg/dL",
              min: 170,
              max: 340
            }
          }
        ];
        if (this.colesterol.value < 170) this.colesterol.label = "Normal";
        else if (this.colesterol.value >= 170)
          this.colesterol.label = "Elevado";
        else this.colesterol.label = "Erro!";
      }
    }

    if (!!this.ldl && !!this.customer.age) {
      let range = 130;
      if (cardiovascular == "Risco Baixo" || cardiovascular == "Baixo") {
        if (this.ldl.value > 190 || this.hasDiabetes) range = 100;
        if (
          this.answerSearch(
            "Você é portador de quais doenças ou condições abaixo?",
            true
          ).includes("Doença Renal Crônica")
        )
          range = 70;
      } else if (cardiovascular == "Risco Médio" || cardiovascular == "Médio") {
        range = 100;
        if (
          this.hasDiabetes ||
          this.answerSearch(
            "Você é portador de quais doenças ou condições abaixo?",
            true
          ).includes("Doença Renal Crônica")
        )
          range = 70;
      } else if (cardiovascular == "Risco Alto" || cardiovascular == "Alto") {
        range = 70;
      } else if (
        cardiovascular == "Risco Muito Alto" ||
        cardiovascular == "Muito Alto"
      ) {
        range = 50;
      } else {
        range = 130;
      }
      if (this.ldl.value < range) this.ldl.label = "Normal";
      else this.ldl.label = "Elevado";
      this.result.exam.result.ldlAlt = {
        range: range,
        label: this.ldl.label
      };
      this.ldl.metric_labels = [
        {
          name: "Normal",
          color: "dark-green",
          interval: { desc: `Inferior a ${range}mg/dL`, min: 0, max: range }
        },
        {
          name: "Elevado",
          color: "red",
          interval: {
            desc: `Igual ou superior a ${range}mg/dL`,
            min: range,
            max: range * 2
          }
        }
      ];
    }

    if (!!this.hdl && !!this.customer.age) {
      if (this.customer.age > 20) {
        this.hdl.metric_labels = [
          {
            name: "Alterado",
            color: "red",
            interval: { desc: "Inferior ou igual a 40mg/dL", min: 0, max: 40 }
          },
          {
            name: "Normal",
            color: "dark-green",
            interval: { desc: "Superior a 40mg/dL", min: 40, max: 80 }
          }
        ];
        if (this.hdl.value <= 40) this.hdl.label = "Alterado";
        else if (this.hdl.value > 40) this.hdl.label = "Normal";
        else this.hdl.label = "ERRO!";
      } else {
        this.hdl.metric_labels = [
          {
            name: "Alterado",
            color: "red",
            interval: { desc: "Inferior ou igual a 45mg/dL", min: 0, max: 45 }
          },
          {
            name: "Normal",
            color: "dark-green",
            interval: { desc: "Superior a 45mg/dL", min: 45, max: 90 }
          }
        ];
        if (this.hdl.value <= 45) this.hdl.label = "Alterado";
        else if (this.hdl.value > 45) this.hdl.label = "Normal";
        else this.hdl.label = "ERRO!";
      }
    }

    if (!!this.triglicerideos && !!this.customer.age) {
      if (this.customer.age < 10) {
        this.triglicerideos.metric_labels = [
          {
            name: "Normal",
            color: "dark-green",
            interval: { desc: "Inferior a 85mg/dL", min: 0, max: 85 }
          },
          {
            name: "Elevado",
            color: "red",
            interval: {
              desc: "Superior ou igual a 170mg/dL",
              min: 85,
              max: 170
            }
          }
        ];
        if (this.triglicerideos.value < 85)
          this.triglicerideos.label = "Normal";
        else if (this.triglicerideos.value >= 85)
          this.triglicerideos.label = "Elevado";
        else this.triglicerideos.label = "ERRO!";
      } else if (this.customer.age >= 10 && this.customer.age < 20) {
        this.triglicerideos.metric_labels = [
          {
            name: "Normal",
            color: "dark-green",
            interval: { desc: "Inferior a 100mg/dL", min: 0, max: 100 }
          },
          {
            name: "Elevado",
            color: "red",
            interval: {
              desc: "Superior ou igual a 100mg/dL",
              min: 100,
              max: 200
            }
          }
        ];
        if (this.triglicerideos.value < 100)
          this.triglicerideos.label = "Normal";
        else if (this.triglicerideos.value >= 100)
          this.triglicerideos.label = "Elevado";
        else this.triglicerideos.label = "ERRO!";
      } else if (this.customer.age >= 20) {
        this.triglicerideos.metric_labels = [
          {
            name: "Normal",
            color: "dark-green",
            interval: { desc: "Inferior a 150mg/dL", min: 0, max: 150 }
          },
          {
            name: "Pouco Elevado",
            color: "yellow",
            interval: { desc: "De 150mg/dL a 199mg/dL", min: 150, max: 200 }
          },
          {
            name: "Elevado",
            color: "red",
            interval: { desc: "Acima de 199mg/dL", min: 200, max: 400 }
          }
        ];
        if (this.triglicerideos.value < 150)
          this.triglicerideos.label = "Normal";
        else if (
          this.triglicerideos.value >= 150 &&
          this.triglicerideos.value < 200
        )
          this.triglicerideos.label = "Pouco Elevado";
        else if (this.triglicerideos.value >= 200)
          this.triglicerideos.label = "Elevado";
        else this.triglicerideos.label = "ERRO!";
      }
    }

    if (!!this.hba1c) {
      this.hba1c.metric_labels = [
        {
          name: "Normal",
          color: "dark-green",
          interval: { desc: "Inferior a 5,7%", min: 0, max: 5.6 }
        },
        {
          name: "Pré-diabéticos",
          color: "yellow",
          interval: { desc: "De 5,7% a 6,4%", min: 5.7, max: 6.4 }
        },
        {
          name: "Diabete Mellitus",
          color: "red",
          interval: { desc: "Igual ou superior a 6,5%", min: 6.5 }
        }
      ];
      if (this.hba1c.value < 5.7) this.hba1c.label = "Normal";
      else if (this.hba1c.value >= 5.7 && this.hba1c.value < 6.5)
        this.hba1c.label = "Pré-diabéticos";
      else if (this.hba1c.value >= 6.5) this.hba1c.label = "Diabete Mellitus";
      else this.hba1c.label = "ERRO!";
    }

    if (!!this.glicose) {
      this.glicose.metric_labels = [
        {
          name: "Hipoglicemia",
          color: "yellow",
          interval: { desc: "Inferior a 70mg/dL", min: 0, max: 70 }
        },
        {
          name: "Normal",
          color: "dark-green",
          interval: { desc: "De 70mg/dL a 99mg/dL", min: 70, max: 100 }
        },
        {
          name: "Glicemia Elevada",
          color: "red",
          interval: { desc: "Acima de 100mg/dL", min: 100, max: 200 }
        }
      ];
      if (this.glicose.value < 70) this.glicose.label = "Hipoglicemia";
      else if (this.glicose.value >= 70 && this.glicose.value < 100)
        this.glicose.label = "Normal";
      else if (this.glicose.value >= 100)
        this.glicose.label = "Glicemia Elevada";
      else this.glicose.label = "ERRO!";
    }

    if (!!this.creatinine && this.result.kit_type.tag_type == 'check-up-saude-preventiva') {
      const now = moment(new Date());
      const birthdate = this.customer.birth_date
      const monthsDiff = now.diff(birthdate, 'months') // 1
      const minLimit = 
        monthsDiff <= 1 ? 0.3
        : this.customer.age <= 2 ? 0.2
        : this.customer.age <= 12 ? 0.3
        : this.customer.age <= 18 ? 0.5
        : this.customer.age > 18 && this.customer.gender == 'M' ? 0.7
        : this.customer.age > 18 && this.customer.gender == 'F' ? 0.5
        : 0.7
      const maxLimit = 
        monthsDiff <= 1 ? 1
        : this.customer.age <= 2 ? 0.4
        : this.customer.age <= 12 ? 0.7
        : this.customer.age <= 18 ? 1
        : this.customer.age > 18 && this.customer.gender == 'M' ? 1.2
        : this.customer.age > 18 && this.customer.gender == 'F' ? 1
        : 1.2

      this.creatinine.metric_labels = [
        {
          name: "Alterado",
          color: "red",
          interval: { desc: `Inferior a 0.5mg/dL`, min: 0, max: minLimit }
        },
        {
          name: "Normal",
          color: "dark-green",
          interval: { desc: `De 0.5mg/dL a 1mg/dL`, min: minLimit, max: maxLimit }
        },
        {
          name: "Alterado ",
          color: "red",
          interval: { desc: `Superior a 1mg/dL`, min: maxLimit, max: maxLimit * 2 }
        },
      ];
      if (this.creatinine.value < minLimit) this.creatinine.label = "Alterado";
      else if (this.creatinine.value >= minLimit && this.creatinine.value <= maxLimit) this.creatinine.label = "Normal";
      else if (this.creatinine.value > maxLimit) this.creatinine.label = "Alterado ";
      else this.creatinine.label = "ERRO!";
    }

    if (!!this.tfg && this.result.kit_type.tag_type == 'check-up-saude-preventiva') {
      this.tfg.metric_labels = [
        {
          name: "Falência Renal",
          color: "purple",
          interval: { desc: "Inferior a 14mL/min x 1,73m²", min: 0, max: 15 }
        },
        {
          name: "Redução Severa",
          color: "red",
          interval: { desc: "De 15mL/min x 1,73m² a 29mL/min x 1,73m²", min: 15, max: 30 }
        },
        {
          name: "Redução Moderada-Severa",
          color: "orange",
          interval: { desc: "De 30mL/min x 1,73m² a 44mL/min x 1,73m²", min: 30, max: 45 }
        },
        {
          name: "Redução Discreta-Moderada",
          color: "yellow",
          interval: { desc: "De 45mL/min x 1,73m² a 59mL/min x 1,73m²", min: 45, max: 60 }
        },
        {
          name: "Redução Discreta",
          color: "green",
          interval: { desc: "De 60mL/min x 1,73m² a 89mL/min x 1,73m²", min: 60, max: 90 }
        },
        {
          name: "Normalidade",
          color: "dark-green",
          interval: { desc: "Acima de 90mL/min x 1,73m²", min: 90, max: 180 }
        },
      ];
      if (this.tfg.value > 90) this.tfg.label = "Normalidade";
      else if (this.tfg.value >= 60 && this.tfg.value <= 89) this.tfg.label = "Redução Discreta";
      else if (this.tfg.value >= 45 && this.tfg.value <= 59) this.tfg.label = "Redução Discreta-Moderada";
      else if (this.tfg.value >= 30 && this.tfg.value <= 44) this.tfg.label = "Redução Moderada-Severa";
      else if (this.tfg.value >= 15 && this.tfg.value <= 29) this.tfg.label = "Redução Severa";
      else if (this.tfg.value <= 14) this.tfg.label = "Falência Renal";
      else this.tfg.label = "ERRO!";
    }
  }
};
</script>
<style scoped>
@import "./kit-results.scss";
@import "./responsive.css";
</style>



// WEBPACK FOOTER //
// src/components/KitResults/KitResults.vue